import { request } from './axios.config';

export type MergeTags = Record<string, unknown>;

function isMergeTags(value: unknown): value is MergeTags {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function combineMergeTags(
    dynamicMergeTags: MergeTags,
    staticMergeTags: MergeTags
): MergeTags {
    const combined = {
        ...dynamicMergeTags,
        ...staticMergeTags,
    };

    return Object.fromEntries(
        Object.entries(combined).sort(([left], [right]) =>
            left.localeCompare(right, undefined, { sensitivity: 'base' })
        )
    );
}

export const mergeTagService = {
    async getMergeTags(): Promise<MergeTags> {
        const mergeTags = await request.get<unknown>('/EmailTemplate/GetMergeTags');
        if (!isMergeTags(mergeTags)) {
            throw new Error('OfficeNext returned an invalid merge-tag response.');
        }

        return mergeTags;
    },
};
